import Cookies from 'js-cookie';

export class Utils {
    public static parseNumber(value = 0, with_currency = false) {
        let number = new Intl.NumberFormat("es").format(value);
        if (with_currency) {
            number = new Intl.NumberFormat("es", { style: "currency", currency: "EUR" }).format(value);
        }
        return number;
    }

    /**
     * Returns current langcode without dash
     * @returns {string}
     */
    public static getLangcode() {
        const currentLang = drupalSettings.path.currentLanguage;
        if (!currentLang.includes('-')) {
            return currentLang;
        }

        return currentLang.split('-')[0];
    }

    /**
     * Returns info stored in cookie or null if no info found
     * @param {string} cookieName
     * @return {json|null} json or null
     */
    public static getDataFromCookie(cookieName: string) {
        return Cookies.get(cookieName);
    }

    /**
     * Store data in cookie. Expires at the end of the day
     */
    public static storeDataInCookie(cookieName: string, data: string, path: string) {
        var expires = "";
        var date = new Date();
        var midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
        expires = "; expires=" + midnight.toGMTString();

        Cookies.set(cookieName, data, {
            path: path,
            expires: midnight
        });
    }
}
